import type { HeroCarouselItemTextProps } from '../hero-carousel'
import { getCustomStyles } from '../utils'

interface TitleProps {
  title?: HeroCarouselItemTextProps
  textAlignment?: CanvasTextAlign
}

export const Title = ({ title, textAlignment }: TitleProps) => {
  const customStylesText = getCustomStyles(title?.styles)

  if (!title) {
    return <></>
  }

  return (
    <>
      {title?.text && (
        <h4
          className="md:text-[40px] sm:text-[40px] text-[32px] pb-2 md:pb-4 font-normal leading-[100%]"
          style={{ ...customStylesText, textAlign: textAlignment }}
        >
          {title?.text}
        </h4>
      )}
    </>
  )
}

export default Title
